import { render, staticRenderFns } from "./add_error.vue?vue&type=template&id=58b235c0&scoped=true&"
import script from "./add_error.vue?vue&type=script&lang=js&"
export * from "./add_error.vue?vue&type=script&lang=js&"
import style0 from "./add_error.vue?vue&type=style&index=0&id=58b235c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b235c0",
  null
  
)

export default component.exports